/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributeTranslationOut
 */
export interface AttributeTranslationOut {
    /**
     * 
     * @type {string}
     * @memberof AttributeTranslationOut
     */
    nameLocal?: string;
    /**
     * 
     * @type {string}
     * @memberof AttributeTranslationOut
     */
    code?: string;
}

export function AttributeTranslationOutFromJSON(json: any): AttributeTranslationOut {
    return AttributeTranslationOutFromJSONTyped(json, false);
}

export function AttributeTranslationOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeTranslationOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nameLocal': !exists(json, 'nameLocal') ? undefined : json['nameLocal'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function AttributeTranslationOutToJSON(value?: AttributeTranslationOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nameLocal': value.nameLocal,
        'code': value.code,
    };
}


